import { isString } from 'lodash';

export const getHashingMetadata = (payload) => (
  isString(payload) ? JSON.parse(payload) : payload
);

export default () => {};



// WEBPACK FOOTER //
// ./src/reducers/portalConfig/responseParser.js